import { useAppSelector } from "Redux/hooks";
import OrganizationBreadcrumbs from "./OrganizationBreadcrumbs";
import Users from "./Users";
import { selectLoadingOrganizations } from "feature/admin/slice";

function Organization() {
  const loadingOrganizations = useAppSelector(selectLoadingOrganizations);
  if (loadingOrganizations) return <div>Loading...</div>;

  return (
    <div className="flex flex-col gap-12">
      <OrganizationBreadcrumbs />
      <Users />
    </div>
  );
}

export default Organization;
